import jsPDF from 'jspdf';
import 'jspdf-autotable';

export const generateProfileReport = (userData) => {
    if (!userData) {
        alert("Não foi possível carregar os dados do usuário para gerar o relatório.");
        return;
    }

    const doc = new jsPDF({
        orientation: 'p',
        unit: 'mm',
        format: 'a4'
    });

    // Título do Documento
    doc.setFontSize(18);
    doc.setTextColor(40);
    doc.text("Relatório de Dados do Perfil", 14, 22);

    // Linha decorativa
    doc.setDrawColor(22, 160, 133); // Verde da página
    doc.line(14, 25, 196, 25);

    // Data de Emissão
    doc.setFontSize(11);
    doc.setTextColor(100);
    doc.text(`Relatório gerado em: ${new Date().toLocaleDateString('pt-BR')}`, 14, 32);

    // Usando autoTable para criar uma tabela bonita com os dados
    doc.autoTable({
        startY: 40,
        head: [['Campo', 'Valor']],
        body: [
            ['Nome de Usuário', userData.username || 'Não informado'],
            // Adicione aqui outros campos do perfil que você possa ter
            // Exemplo: ['Email', userData.email || 'Não informado'],
            // Exemplo: ['Membro desde', new Date(userData.createdAt).toLocaleDateString('pt-BR') || 'Não informado'],
        ],
        theme: 'striped',
        headStyles: {
            fillColor: [22, 160, 133], // Verde da página
            textColor: 255,
            fontSize: 12
        },
        styles: {
            fontSize: 11,
            cellPadding: 3
        }
    });

    // Rodapé
    const pageCount = doc.internal.getNumberOfPages();
    for (let i = 1; i <= pageCount; i++) {
        doc.setPage(i);
        doc.setFontSize(9);
        doc.setTextColor(150);
        doc.text(`Página ${i} de ${pageCount}`, 14, doc.internal.pageSize.height - 10);
    }

    // Salva o PDF
    doc.save(`relatorio_perfil_${userData.username}.pdf`);
};